import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useAsyncValidateEmail } from 'hooks/useAsyncValidations';

const useValidateEmail = () => {
  const intl = useIntl();
  const { mutateAsync: validateEmail } = useAsyncValidateEmail();

  const validate = useCallback(
    async (value) => {
      if (!value) {
        return true;
      }
      const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if (!emailPattern.test(value)) {
        return false;
      }

      const emailIsValid = await validateEmail(value);
      if (emailIsValid) {
        return true;
      }

      return intl.formatMessage({
        id: 'afforda.formHouseholdProfile.emailInvalid',
      });
    },
    [intl, validateEmail],
  );

  const debouncedValidate = useMemo(() => {
    let timeout;
    return (value) =>
      new Promise((resolve) => {
        clearTimeout(timeout);
        timeout = setTimeout(async () => {
          const result = await validate(value);
          resolve(result);
        }, 300);
      });
  }, [validate]);

  return debouncedValidate;
};

export default useValidateEmail;
